<app-header></app-header>
<app-breadcrumb></app-breadcrumb>

<div class="min-height">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
